module.exports = __webpack_public_path__ + "static/voip-67b209ef09f8b238a7f06ac2960ef8fe.jpg";